import { render, staticRenderFns } from "./Callus.vue?vue&type=template&id=840f16b0&scoped=true&"
import script from "./Callus.vue?vue&type=script&lang=js&"
export * from "./Callus.vue?vue&type=script&lang=js&"
import style0 from "./Callus.vue?vue&type=style&index=0&id=840f16b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840f16b0",
  null
  
)

export default component.exports